const BasicSet = () => import('@/vuepage/seo-manage/basicSet')
const WebMap = () => import('@/vuepage/seo-manage/webMap')
export default [
    {
        path: '/basic-set',
        component: BasicSet,
        meta: [
            { name: 'SEO设置' },
            { name: '基础设置', activeRoute: '/basic-set' }
        ]
    },

    {
        path: '/web-map',
        component: WebMap,
        name: '/web-map',
        meta: [
            { name: 'SEO设置' },
            { name: '网站地图管理', activeRoute: '/web-map' }
        ]
    }
]
